<template>
  <c-modal v-if="site" class="edit-client" :title="title" size="sm" :show="show" @update:show="toggle">
    <c-select :value="site.clientId" :options="clients" :disabled="isSaving" @update:value="selectClient" />

    <template v-slot:footer>
      <c-button-group>
        <c-button color="primary" @click="save">
          <c-spinner v-if="isSaving" color="success" size="sm" />
          <span v-else>Update client</span>
        </c-button>
        <c-button v-if="!isSaving" color="secondary" @click="toggle(false)">Cancel</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import EditDetails from '@/views/components/site/edit-details';
import EditAuthentication from '@/views/components/site/edit-authentication';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditSiteClient',
  components: {
    EditAuthentication,
    EditDetails,
  },
  props: {
    show: Boolean,
    site: Object,
  },
  data() {
    return {
      error: null,
      clients: [],
      isLoading: true,
      isSaving: false,
      selectedOption: null,
    };
  },
  computed: {
    title() {
      return `Set client for site`;
    },
  },
  watch: {
    show(v) {
      if (!v) {
        this.selectedOption = null;
        this.isSaving = false;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    selectClient(e) {
      this.selectedOption = e;
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .get(buildEndpoint(`clients/list/${this.$store.state.app.authenticatedUser.organisationId}`))
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.clients = response.data.data.map((client) => ({
              value: client._id,
              label: client.name,
            }));
            this.clients.unshift({
              value: null,
              label: 'Select a client',
            });
          }
        })
        .catch((error) => {
          this.clientError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    save() {
      if (!this.selectedOption) {
        return;
      }
      this.isSaving = true;
      this.error = null;
      const data = {
        siteId: this.site._id,
        clientId: this.selectedOption,
      };
      this.$http
        .post(buildEndpoint('site/client/update'), data)
        .then((response) => {
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Client updated',
            });
            const newClient = this.clients.find((client) => client.value === this.selectedOption);
            this.$emit('updated', newClient);
            this.toggle(false);
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
